import { Dialog, DialogContent, DialogTitle, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from 'react-i18next';
import { EmployeeFeriasManager } from './EmployeeFeriasManager';

export interface EmployeeFeriasDialogProps {
  open: boolean;
  employeeId: number | null;
  employeeName?: string;
  onClose: () => void;
}

export function EmployeeFeriasDialog({
  open,
  employeeId,
  employeeName,
  onClose,
}: EmployeeFeriasDialogProps): JSX.Element {
  const { t } = useTranslation();

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        {employeeName
          ? t('features.colaboradores.ferias.dialogTitleNamed', { nome: employeeName })
          : t('features.colaboradores.ferias.dialogTitle')}
        <IconButton onClick={onClose} aria-label={t('common.close')} size="small">
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        {employeeId !== null && <EmployeeFeriasManager employeeId={employeeId} />}
      </DialogContent>
    </Dialog>
  );
}
